export const JWT_SESSION_STORAGE_NAME = "starlog_jwt";
